import React, { useState, useEffect } from 'react'

import ContestItem from '../ContestItem'

import Contest from '../../../../services/Contest'

import './styles.css'

function ContestSection() {
  const [contests, setContests] = useState([])

  useEffect(() => {
    Contest.readInAnalysis()
      .then(res => {
        setContests(res)
      })
      .catch(err => {
        alert('Erro ao processar requisição')
        console.log('ErrorName: ' + err.name + 'ErrorMessage: ' + err.message)
      })
  }, [])

  return (
    <div id="contest-section">
      {!contests.length ? (
        <div className="empty-contests">
          <span>Ninguém submeteu concurso ainda!</span>
        </div>
      ) : (
        <>
          <div className="title-content-contest">
            <h3 className='title-contest'>Concursos</h3>
          </div>
          <div className="scroll-content-contest">
            <ul className="contests-list">
              {contests.map(contest => (
                <ContestItem
                  id={contest.id}
                  title={contest.title}
                  categoria={contest.category}
                  key={contest.id}
                />
              ))}
            </ul>
          </div>
        </>
      )}
      
    </div>
  )
}

export default ContestSection